import React, { useEffect } from 'react'
import { Fieldset } from 'primereact/fieldset'
import { InputTextarea } from 'primereact/inputtextarea'
import { SplitButton } from 'primereact/splitbutton'
import { connect } from 'react-redux'
import {
  Btn,
  CustomCalendar,
  CustomCard,
  CustomCheckbox,
  CustomDropdown,
  InputNumeroDecimal,
  InputPlacaVeiculo,
  InputText,
  InputTime,
} from '../../../../../components'
import {
  urlGetImprimirEmitirResumo,
  urlGetImprimirEmitirResumoFaltasPorArea,
} from '../../../../../services/api/routes/picking.routes'
import useEmitirResumo, { LOAD_MESSAGE } from './EmitirResumoHook'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import { DateTime } from 'luxon'

function EmitirResumo({ faltasItems, sobrasItems, tipo, selectedPicking, selectedTp, dispatch }) {
  const { state, localDispatch } = useEmitirResumo()

  const openResumoSeparacao = () => {
    window.open(
      urlGetImprimirEmitirResumo(selectedPicking.id, selectedPicking.company_id),
      '_blank',
    )
  }

  const reportItems = [
    {
      label: 'Resumo de Separação - Faltas Por Área',
      command: () =>
        window.open(urlGetImprimirEmitirResumoFaltasPorArea(selectedPicking.id), '_blank'),
    },
  ]

  useEffect(() => {
    localDispatch.onInit(selectedPicking)
  }, [selectedPicking])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.FINALIZANDO_RESUMO:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde . . .'))
        localDispatch.finalizarResumo(state.selectedPicking)
        break
      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        break

      case LOAD_MESSAGE.GET_MOTIVOS:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde . . .'))
        localDispatch.getMotivosAtraso(selectedTp)
        break

      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <div>
      <Fieldset legend="Informações do Veículo de Transferência">
        <div className="p-grid">
          <div className="p-col-3">
            <InputText
              disabled={state.isDisabled}
              marginTop={0}
              label="Nome do Motorista(*)"
              value={
                state.selectedPicking.t1_driver_name ? state.selectedPicking.t1_driver_name : ''
              }
              onChange={value => localDispatch.onInputChange('t1_driver_name', value)}
            />
          </div>
          <div className="p-col-2">
            <InputPlacaVeiculo
              disabled={state.isDisabled}
              marginTop={0}
              label="Placa do Veiculo(*)"
              value={
                state.selectedPicking.t1_vehicle_plate ? state.selectedPicking.t1_vehicle_plate : ''
              }
              onChange={value => localDispatch.onInputChange('t1_vehicle_plate', value)}
            />
          </div>
          <div className="p-col-2">
            <CustomCalendar
              disabled={state.isDisabled}
              label="Data de Chegada(*)"
              marginTop={0}
              value={
                state.selectedPicking.t1_arrived_date
                  ? DateTime.fromJSDate(state.selectedPicking.arrived_date).toJSDate()
                  : ''
              }
              onChange={value => localDispatch.onInputDateChange(value)}
            />
          </div>
          <div className="p-col-2">
            <InputTime
              disabled={state.isDisabled}
              marginTop={0}
              label="Horário de Chegada(*)"
              value={
                state.selectedPicking.t1_arrived_time ? state.selectedPicking.t1_arrived_time : ''
              }
              onChange={value => localDispatch.onInputChange('t1_arrived_time', value)}
            />
          </div>
          <div className="p-col-2">
            <InputText
              disabled={state.isDisabled}
              marginTop={0}
              label="Código do Lacre"
              value={state.selectedPicking.codigo_lacre ? state.selectedPicking.codigo_lacre : ''}
              onChange={value => localDispatch.onInputChange('codigo_lacre', value)}
            />
          </div>
        </div>
        <div className="p-grid">
          <div className="p-col-3">
            <CustomCalendar
              disabled={state.isDisabled}
              label="Data de Operação(*)"
              marginTop={0}
              value={
                state.selectedPicking.t1_data_operacao
                  ? DateTime.fromJSDate(state.selectedPicking.t1_data_operacao).toJSDate()
                  : ''
              }
              onChange={value => localDispatch.onInputChange('t1_data_operacao', value)}
            />
          </div>
          <div
            className="p-col-2 p-col-align-center p-col-justify-center"
            style={{ paddingTop: 25 }}
          >
            <CustomCheckbox
              disabled={state.isDisabled}
              onChange={value => localDispatch.onInputChange('transfer_vehicle_lated', value)}
              checked={state.selectedPicking.transfer_vehicle_lated}
            >
              Veiculo Atrasado
            </CustomCheckbox>
          </div>
          <div className="p-col-4" style={{ paddingTop: 0 }}>
            <CustomDropdown
              disabled={state.isDisabled || !state.selectedPicking.transfer_vehicle_lated}
              optionLabel="name"
              options={state.motivosAtraso}
              value={state.selectedMotivoAtraso}
              label="Motivo de Atraso :*"
              filter={true}
              onChange={value => localDispatch.onMotivoChange(value)}
            />
          </div>
          <div className="p-col-2">
            <InputNumeroDecimal
              disabled={state.isDisabled}
              marginTop={0}
              label="Temperatura Thermo King"
              value={
                state.selectedPicking.temp_thermo_king ? state.selectedPicking.temp_thermo_king : ''
              }
              onChange={value => localDispatch.onInputChange('temp_thermo_king', value)}
            />
          </div>
        </div>
      </Fieldset>
      <div style={{ marginTop: 20 }}>
        <label style={{ fontSize: '0.8rem', color: '#14B0BF', display: 'block', marginBottom: 4 }}>
          Observação :
        </label>
        <InputTextarea
          disabled={state.isDisabled}
          autoResize
          rows={4}
          style={{ width: '100%', resize: 'none' }}
          placeholder="Digite uma observação sobre esta separação (opcional)"
          value={state.selectedPicking.obs_resumo_separacao || ''}
          onChange={e => localDispatch.onInputChange('obs_resumo_separacao', e.target.value)}
        />
      </div>
      <div className="p-grid" style={{ marginTop: 20 }}>
        <div className="p-col-3">
          <CustomCard title="Total de Faltas" subTitle="Vol./Caixa e Uni.">
            {localDispatch.getTotalFaltas(faltasItems, tipo)}
          </CustomCard>
        </div>
        <div className="p-col-3">
          <CustomCard title="Total de Sobras" subTitle="Vol./Caixa e Uni.">
            {localDispatch.getTotalSobras(sobrasItems)}
          </CustomCard>
        </div>
        <div className="p-col-12">
          <Btn disabled={state.isDisabled} onClick={localDispatch.onBtnFinalizarResumo}>
            Finalizar Resumo de Separação
          </Btn>
          <div style={{ display: 'inline-block', marginLeft: 10 }}>
            <SplitButton
              menuStyle={{ width: 310 }}
              disabled={!state.isDisabled}
              className="bck-primary"
              label="Imprimir Resumo de Separação"
              icon="pi pi-print"
              onClick={openResumoSeparacao}
              model={reportItems}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
const mapStateToProps = ({ picking: { selectedPicking }, system: { selectedTp } }) => ({
  selectedPicking,
  selectedTp,
})
export default connect(mapStateToProps)(EmitirResumo)
